// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3tRfM","calendarButtons":"ClockData_calendarButtons__1ld3i"};